import { render, staticRenderFns } from "./ModalGaleriaImagem.vue?vue&type=template&id=635b96b0&scoped=true&"
import script from "./ModalGaleriaImagem.vue?vue&type=script&lang=js&"
export * from "./ModalGaleriaImagem.vue?vue&type=script&lang=js&"
import style0 from "./ModalGaleriaImagem.vue?vue&type=style&index=0&id=635b96b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b96b0",
  null
  
)

export default component.exports